<template>
  <div class="lg-section flex ti-page-start px3">
    <div class="sm-col sm-col-12 md-col-8">
      <div v-if="report" class="pb2">
        <div class="lg-section pb2">
          <router-link :to="{name: 'report-list'}" class="ti-link">
            🡸 Reports & Insights
          </router-link>
        </div>
        <h1 class="blog-title pb1">{{report.title}}
          <span v-if="report.status=='DRAFT'" style="color:red">(DRAFT)</span>
        </h1>
        <div class="flex flex-wrap items-center">
          <div class="blog-card-date py2 flex-auto">
            <span v-if="report.report_type">{{report.report_type_label}} |</span>
            <span v-if="report.white_paper">WHITE PAPER |</span>
            <span v-else-if="report.essential_read">ESSENTIAL READING |</span>
            <!-- <span v-else-if="report.ti_group">USER GROUP |</span> -->
            {{ report.date_us_str }}
            <template v-if="report.authors"> |
              <span v-for="(author, index) in report.authors" :key="author.name">
                <a :href="author.url" class="report-card-author">
                  {{ author.name }}
                </a>
                <span v-if="index+1 < report.authors.length"> ; </span>
              </span>
            </template>

          </div>
          <div v-if="report.shareLink" style="line-height:1px;">
            <ShareLinks :path="report.shareLink"
                        :text="`Transforma Insights Report: ${report.title}`"/>
          </div>
        </div>

        <!-- report_props -->
        <div v-if="report.num_pages" class="ti-card-prop-label">Number of Pages:
          <span class="ti-card-prop-value">
            {{ report.num_pages }}
          </span>
        </div>

        <div v-if="report.organizations.length" class="ti-card-prop-label">
          <span style="margin-right:6px;">Organisations covered:</span>
          <span v-for="(org, index) in report.organizations" :key="org.name" >
            <a v-if="org.url" class="ti-link" style="font-size:14px;"
               :href="org.url">{{ org.name }}</a>
            <span v-else class="ti-card-prop-value-list">
              {{org.name}}
            </span>
            <span v-if="index+1 < report.organizations.length"> | </span>
          </span>
        </div>

        <div v-if="report.keywords.length" class="ti-card-prop-label">
          <span style="margin-right:6px;">Keywords:</span>
          <span v-for="(word, index) in report.keywords" :key="index" >
            <span class="ti-card-prop-value-list">
              {{word.name}}
            </span>
            <span v-if="index+1 < report.keywords.length"> | </span>
          </span>
        </div>

        <div style="line-height:24px; padding: 4px 0;">
          <TransformaTags label="region" :low="true" :small="true"
                          :all="report.region_all" :items="report.regions"/>
          <TransformaTags label="sector" :low="true" :small="true"
                          :all="report.sector_all" :items="report.sectors"/>
          <TransformaTags label="technology" :low="true" :small="true"
                          :all="report.technology_all" :items="report.technologies"/>
        </div>

        <form v-if="report.has_doc && report.can_download"
              @submit="preDownload(report.slug)"
              method="post"
              :action="`/research/report-download/${report.slug}`">
          <input v-for="question in (report.download_questions || [])"
                 :key="question.key"
                 type="hidden"
                 :name="`answer_${question.key}`"
                 :value="selectedAnswers[question.key] || ''">
          <div class="pt3">
            <button class="btn btn-primary" @click="onDownloadClick">
              Download report
            </button>
          </div>
        </form>

        <div class="ti-page py3" v-html="report.content"></div>

        <div v-if="report.iframe==='no-access'" class="mb2">
          <a v-if="report.thumbnail" href="/signup">
            <img :src="report.thumbnail" width="500px"></img>
          </a>
          <template v-else> <!-- display only if has no doc to avoid duplicate-->
            <div v-if="!report.has_doc">
              <a href="/login" class="ti-link">Login</a> to access this video.
            </div>
          </template>
        </div>
        <template v-else-if="report.iframe">
          <div class="ti-page py3" v-html="report.iframe"></div>
        </template>

        <form v-if="report.has_doc"
              @submit="preDownload(report.slug)"
              method="post"
              :action="`/research/report-download/${report.slug}`">
          <input v-for="question in (report.download_questions || [])"
                 :key="question.key"
                 type="hidden"
                 :name="`answer_${question.key}`"
                 :value="selectedAnswers[question.key] || ''">
          <div>
            <button v-if="report.can_download" class="btn btn-primary"
                    @click="onDownloadClick">
              Download report
            </button>
            <template v-else>
              <input type="button" class="btn btn-primary" disabled value="Download report"/>
              <div style="margin-top:4px;">
                <template v-if="report.white_paper">
                  <a href="/login" class="ti-link">Log in</a> or
                  <a href="/signup" class="ti-link">sign up</a>
                  to a free ESSENTIAL subscription to access.
                </template>
                <span v-else-if="report.essential_read">
                  <a href="/login" class="ti-link">Log in</a> or
                  <a href="/signup" class="ti-link">sign up</a>
                  to a free ESSENTIAL subscription to access.
                </span>
                <!-- TODO: message for user group -->
                <!-- <span v-else-if="report.ti_group"> -->
                  <!--   <a href="/login" class="ti-link">Log in</a> or -->
                  <!--   <a href="/signup" class="ti-link">sign up</a> -->
                  <!--   to a free ESSENTIAL subscription to access. -->
                  <!-- </span> -->
                <a v-else class="ti-link pr2" style="font-weight:normal;"
                   href="/research/overview">
                  View offerings
                </a>
              </div>
            </template>
          </div>
        </form>

        <div v-if="report.transcript" class="py3">
          <h2 class="ti-h2" style="margin-bottom:0.5rem;">Video Transcript</h2>
          <div class="py1">
            <div v-html="report.transcript" class="ti-page py3 transcript-box"/>
          </div>
        </div>

      </div>
    </div>

    <!-- right-side column -->
    <div class="sm-col sm-col-12 md-col-4 pl2">
      <template v-if="related && related.length!==0">
        <h3 class="ti-h3 pl2 mb2">Related Content</h3>
        <div v-for="report in related" :key="report.id" class="mt1 mb2 pb1 report-card">
          <router-link :to="{name: 'report-detail', params: {slug: report.slug}}"
                       class="link-wrapper mt1">
            <ReportCard :report="report" :showTags="false" :showOrgs="false" :introLong="false" />
          </router-link>
        </div>
      </template>
    </div>

    <ReportQuestionsModal v-if="showQuestionsModal"
                          :questions="pendingQuestions"
                          @confirm="onQuestionsConfirm"
                          @close="showQuestionsModal = false" />
  </div>
</template>

<script>
import axios from 'axios';

import TransformaTags from '@/components/TransformaTags.vue';
import ShareLinks from '@/components/ShareLinks.vue';
import ReportCard from '@/components/ReportCard.vue';
import ReportQuestionsModal from './ReportQuestionsModal.vue';

/* global gtag */


export default {
  name: 'ReportDetail',
  components: {
    TransformaTags,
    ShareLinks,
    ReportCard,
    ReportQuestionsModal,
  },
  data() {
    return {
      loading: true, // first load of refMap
      objSlug: this.$route.params.slug,
      report: null,
      related: null,

      showQuestionsModal: false,
      pendingForm: null,
      pendingQuestions: [],
      selectedAnswers: {},
    };
  },

  computed: {
  },

  created() {
    if (this.$store.state.detail) {
      this.report = this.$store.state.detail;
      this.$store.state.detail = null;
      // related content not included SSR
      axios.get(`/api/reports/${this.objSlug}?related=1`)
        .then((res) => {
          this.related = res.data.related;
        });
      this.loading = false;
    } else {
      axios.get(`/api/reports/${this.objSlug}`)
        .then((res) => {
          this.report = res.data.report;
          this.related = res.data.related;
          this.loading = false;
          document.title = this.report.title;
        });
    }

    // SEO content displayed only on list page.
    const seo = document.getElementById('report-bottom');
    if (seo) {
      seo.style.display = 'none';
    }
  },

  methods: {
    preDownload(slug) {
      // send GA event
      if (window.GA_ID !== undefined) {
        gtag('event', 'report_download', {
          event_category: 'report',
          event_label: slug,
          value: 1, // 1 means download from detail page
        });
      }
    },
    onDownloadClick(event) {
      const questions = (this.report && this.report.download_questions) || [];
      if (questions.length === 0) return; // no question -> native submit
      event.preventDefault();
      this.pendingForm = event.target.form;
      this.pendingQuestions = questions;
      this.selectedAnswers = {};
      this.showQuestionsModal = true;
    },
    async onQuestionsConfirm(answers) {
      this.selectedAnswers = { ...answers };
      this.showQuestionsModal = false;
      await this.$nextTick();
      // requestSubmit (not submit) so the form's @submit listener fires
      // and the existing GA event is still recorded.
      this.pendingForm.requestSubmit();
    },
  },
};
</script>

<style>
  .transcript-box {
    max-height: 400px;
    overflow: scroll;
    padding: 1rem;
    border: 1px solid #CCC;
    border-radius: 10px;
  }
</style>
